<template lang="html">
  <div>
    <div class="team-list">
      <TeamListItem v-for="child in children" :key="child.id" :resource="child" />
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TeamListItem from 'beisheim/components/blocks/team-list-item'

export default {
  components: {
    TeamListItem
  },
  mixins: [editable],
  computed: {
    children () {
      return sortBy(this.resource.children, 'sort_key')
    }
  },
  methods: {
    getImageAlt (member) {
      const info = member.metaInformation
      return info.media.alt ||
        `${info.name} - ${info.position} - Otto Beisheim Stiftung`
    },
    memberTo (member) {
      return {
        name: this.memberRoute,
        params: {
          memberSlug: member.metaInformation.shortSlug
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~beisheim/scss/scale';
  @import '~beisheim/scss/fluid-type';
  @import '~beisheim/scss/grid';
  @import '~beisheim/scss/breakpoints';
  @import '~beisheim/scss/font';

  .team-list {
    display: flex;
    flex-direction: column;
    margin: scale(16) auto scale(8) auto;
    min-width: $min-width;
    max-width: $max-width;

    @include from(4) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__item {
      display: flex;
      flex-direction: column;
      margin-bottom: scale(12);

      @include to(3) {
        @include grid-spacing(padding-left, 2);
        &:nth-child(2n) {
          padding-left: 0;
          @include grid-spacing(padding-right, 2);

          .team-list__name,
          .team-list__position {
            @include grid-spacing(padding-left, 2);
          }
        }
      }

      @include from(4) {
        @include grid-spacing(padding-right, 1);
        flex-grow: 1;
        justify-content: center;

        .team-list__text {
          padding-left: scale(3);
        }

        &:nth-child(3n) {
          padding-right: 0;
        }
      }
    }

    &__image-wrapper {
      overflow: hidden;
      margin-bottom: scale(4);
      align-self: center;
    }

    &__image {
      min-width: 100%;
      max-width: 480px;
      transition: transform 300ms ease-in-out;
      margin: 0;

      &:hover {
        transform: scaleX(1.1) scaleY(1.1);
      }

      @include from(4) {
        min-width: auto;
        // max-height: 100vw * 0.3;
      }
    }

    &__name {
      @include font(0.5);
      display: block;
      margin-bottom: scale(1);
    }

    &__position {
      @include font(0.5);
      margin-bottom: scale(1);
    }
  }
</style>
